export default ["black", "white", "gray"];
